import { cssJoin } from '@volvo-cars/css/utils';

import Markdown from 'molecules/Markdown';

import styles from './StepList.module.css';

type ListItem = {
  heading: string;
  body: string;
  step: number;
};

type StepListProps = { items: Omit<ListItem, 'step'>[] };

const StepList: React.FC<StepListProps> = ({ items }) => (
  <ol className="flex-col gap-4">
    {items.map(({ heading, body }, i) => (
      <StepListItem key={i} heading={heading} body={body} step={i + 1} />
    ))}
  </ol>
);

const StepListItem: React.FC<ListItem> = ({ heading, body, step }) => (
  <li className="gap-4 flex-col">
    <div className="flex-row">
      <div className={styles.step}>
        <p className="text-secondary">{step}</p>
      </div>
      <div>
        <p className={cssJoin('font-medium font-20', styles.text)}>{heading}</p>
      </div>
    </div>
    <div className="flex-row">
      <div className={styles.strokeWrapper}>
        <div className={styles.stroke} />
      </div>
      <div>
        <div className={cssJoin('mb-32', styles.text)}>
          <Markdown>{body}</Markdown>
        </div>
      </div>
    </div>
  </li>
);

export default StepList;
